import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { userDataUpdate } from "../hooks/apiAxios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import moment from 'moment';
import { maxDate, minDate } from "../utilities/validations/dateValidations";
import SuccessErrorMsg from "../utilities/SuccessErrorMsg";
import { handleImageChange } from "../utilities/handleFunctions/HandelImageChange"
import { useTranslation } from 'react-i18next';
import { useUser } from "../context/User/UserContext";

export default function MyAccount() {
    // const [error, setError] = useState(null);
    const { t, i18n } = useTranslation();
    const { profile, loading } = useUser();

    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const [image, setImage] = useState("/images/user0-img.jpg");
    const [showPassword, setShowPassword] = useState(false);

    const userImage = profile?.data?.image
    const isoDate = profile?.data?.birthDate;
    const formattedBirthDate = moment(isoDate).format('YYYY-MM-DD');

    async function onSubmit(formData) {
        // setLoading(true);
        try {
            const response = await userDataUpdate(formData);

            if (response.data.isSuccess) {
                // setDataUpdate(true);
                toast.success(t("DataSuccess"))
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
                console.log(formData);

            } else {
                toast.error(t("errorTryAgain"));
            }
        } catch (error) {
            console.error("Error during form submission: ", error.response.data.message);
            switch (error.response.status) {
                case 413:
                    toast.warn(t("FileLarg"));
                    break;
                case 400:
                    toast.warn(t("errorCorrectData"));
                    break;
                default:
                    toast.warn(t("errorGetSupport"));
            }

        } finally {
            // setLoading(false);
        }
    }

    // if (error) return <div className="text-center my-4 text-danger">{error}</div>;
    if (loading) return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    if (!profile) return <div className="text-center my-4 text-danger">{t("errorLoadProfile")}</div>;

    moment.locale('en');

    return (

        <div className="container mt-3 rounded bg-dark-beige pb-3 mb-3">
            <form className='d-flex flex-column flex-md-row gap-2'
                onSubmit={handleSubmit(onSubmit)}>

                <div className="d-flex flex-column col-11 col-md-8 mx-auto my-5 gap-3">

                    <div className="input-group input-group-sm">
                        <span className="input-group-text">{t("firstName")}</span>
                        <input className={`form-control ${errors.firstName && "border border-danger"}`} type="text" placeholder={t("firstName")}
                            defaultValue={profile?.data?.firstName}
                            {...register("firstName", { required: true, minLength: 3 })} />
                        {errors.firstName && <p className='errors-msg'>{t("errorNameShort")}</p>}
                    </div>
                    <div className="input-group input-group-sm">
                        <span className="input-group-text">{t("lastName")}</span>
                        <input className={`form-control ${errors.lastName && "border border-danger"}`} type="text" placeholder={t("lastName")}
                            defaultValue={profile?.data?.lastName}
                            {...register("lastName", { required: true, minLength: 3 })} />
                        {errors.lastName && <p className='errors-msg'>{t("errorNameShort")}</p>}
                    </div>

                    <div className="input-group input-group-sm">
                        <span className="input-group-text" >{t("Email")}</span>
                        <input className='form-control' type="text" placeholder={t("Email")}
                            disabled
                            value={profile?.data?.email}
                            {...register("email")} />
                        {errors.email && <p className='errors-msg'>{t("errorEmail")}</p>}
                    </div>

                    <div className="input-group input-group-sm">
                        <span className="input-group-text" >{t("Phone")}</span>
                        <input className='form-control text-start' type="tel" placeholder="05xxxxxxxx"
                            defaultValue={profile?.data?.mobilePhone}
                            {...register("mobilePhone", { required: true })} />
                        {errors.mobilePhone && <p className='errors-msg'>{t("errorPhone")}</p>}
                    </div>


                    <div className="input-group input-group-sm">
                        <span className="input-group-text" >{t("BirthDate")}</span>
                        <input
                            className='form-control text-start'
                            type="date"
                            placeholder={t("BirthDate")}
                            defaultValue={formattedBirthDate}
                            min={minDate}
                            max={maxDate}
                            {...register("birthDate")} />
                        {!isoDate && <span className="input-group-text text-warning" ><FontAwesomeIcon icon={faTriangleExclamation} /></span>}
                    </div>
                    {errors.birthDate && <p className='errors-msg'>{t("errorBirthDate")}</p>}
                    <div className="input-group input-group-sm">
                        {/* <span className="input-group-text" >{t("Reset Password")}</span> */}
                        <input className='form-control'
                            type={showPassword ? "text" : "password"}
                            placeholder={t("Reset Password")}
                            name='password'
                            maxLength={16}
                            minLength={8}
                            onChange={e => setValue("password", e.target.value)}
                        />
                        <span className="input-group-text"
                            onClick={() => setShowPassword(!showPassword)}>
                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                        </span>
                        {errors.password && <p className='errors-msg'>{t("errorPassword")}</p>}
                    </div>

                </div>

                <div className="d-flex flex-column col-11 col-md-3 mx-auto my-1 my-md-5 gap-3 justify-content-between">

                    <p className="notice-font p-0 opacity-50 text-white text-center">{i18n.language === "ar" ?
                        "الحد الأقصى للملف ١٠٠ كيلوبايت" :
                        "Max file size 100KB"}</p>
                    <div className="profile-image-container position-relative mx-auto">
                        <img crossOrigin="anonymous"
                            className="profile-image mx-auto"
                            src={!userImage ? image : (image !== '/images/user0-img.jpg' ? image : userImage)}
                            // src={image !== '/images/user0-img.jpg' ? image : userImage}
                            alt={`${profile?.data?.role}_${profile?.data?.id}_Img`}

                        />
                        <h6 className="profile-change-text border text-center">{t("Change Photo")}</h6>
                        <input
                            className=" opacity-0 profile-image-input"
                            type="file"
                            accept="image/jpeg"
                            onChange={(e) => handleImageChange(e, setValue, setImage, toast, t)}
                        />
                    </div>

                    <button
                        className='btn-masar btn-dark-orange text-white w-75 mx-auto'
                        type="submit">
                        {loading &&
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"></span>
                        }
                        {t("Save")}
                    </button>

                </div>
            </form>
            <SuccessErrorMsg
                ToastContainer={ToastContainer}
            />
        </div>
    )
};
